import create from 'zustand';
import { immer } from 'zustand/middleware/immer'
import {SortParams} from "@/components/SortIndicator";
import { SortPostParams } from "@/containers/admin/Groups/GroupList"

export const GroupListHeader = [
  {
    headerName:'グループ名',
    sortItemName: 'name',
  },
  {
    headerName:'表示用グループ名',
    sortItemName: 'display_name',
  },
];

const initState = {
  queryParams: undefined,
  childSubmit: () => {
  },
  sortParams: {} as SortParams,
  doSort: () => {
  },
}

type GroupStore = {
  queryParams: SortPostParams | undefined;
  setQueryParams: (any: any | undefined) => void;
  sortParams: SortParams;
  setSortParams: (sortParams: SortParams) => void;
  doSort: (sortParams: SortParams) => void;
  setDoSort: (func: GroupStore['doSort']) => void;

};

export const useGroupStore = create<GroupStore>()(
  immer((set) => ({
    ...initState,
    setQueryParams: (queryParams) =>
      set((state) => ({
        queryParams: queryParams,
      })),
    setSortParams: (sortParams) =>
      set((state) => ({
        sortParams: sortParams,
      })),
    setDoSort: (doSort) =>
      set((state) => ({
        doSort: doSort,
      }))
  }))
);
